<template>
  <b-container fluid>
    <b-row>
      <b-col md="3" class="bcol"></b-col>
      <b-col md="6" class="bcol mr-md-auto p-2">
        <b-modal
          id="modal-resume"
          centered
          title="You have an Unfinished Test"
          ok
          hide-footer
          hide-header
        >
          <p>You have an Unfinished Test which will resume in {{ countdown }}secs</p>
        </b-modal>
        <div class="root">
          <div class="select-wrap" style="min-height: 400px">
            <div class="d-flex justify-content-between">
              <div>
                <b-button
                  v-if="currentStep > 1"
                  class="mb-3"
                  @click="currentStep > 0 ? (currentStep = currentStep - 1) : ''"
                  variant="outline-dark"
                >
                  <b-icon-arrow-bar-left size="lg"></b-icon-arrow-bar-left>
                  Go back
                </b-button>
              </div>

              <b-button
                v-if="
                  (currentStep < 4 && structure == 'Subject') ||
                  (currentStep < 5 && structure == 'Section')
                "
                class="mb-3"
                @click="currentStep > 0 ? (currentStep = currentStep + 1) : ''"
                variant="outline-dark"
              >
                Go Forward
                <b-icon-arrow-bar-right size="lg"></b-icon-arrow-bar-right>
              </b-button>
            </div>

            <div
              style="color: #243057; gap: 7px; font-weight: bold"
              class="stepper d-flex flex-nowrap overflow-x-auto"
            >
              <p class="stepper-text" v-if="currentStep >= 1">
                {{ payload.category ? payload.category : "Select Category" }}
              </p>
              <b-icon-chevron-right
                font-scale="1"
                class="mt-1"
                v-if="currentStep >= 1"
              ></b-icon-chevron-right>
              <p class="stepper-text" v-if="currentStep >= 2 && sameName != 'Yes'">
                {{
                  payload.institution
                    ? currentInstitutionObj?.short_name
                    : currentCategoryObj?.children_nomenclature?.length > 0 ? "Select " + currentCategoryObj?.children_nomenclature : "Select Institution"
                }}
              </p>
              <b-icon-chevron-right
                font-scale="1"
                class="mt-1"
                v-if="currentStep >= 2 && sameName != 'Yes'"
              ></b-icon-chevron-right>
              <p class="stepper-text" v-if="currentStep >= 3 && structure == 'Subject'">
                {{
                  payload.institution ? payload.subjects.join(", ") : "Select Subject(s)"
                }}
              </p>
              <b-icon-chevron-right
                font-scale="1"
                class="mt-1"
                v-if="currentStep >= 3 && structure == 'Subject'"
              ></b-icon-chevron-right>
              <p class="stepper-text" v-if="currentStep >= 3 && structure == 'Section'">
                {{ payload.institution ? payload.level : "Select Level" }}
              </p>
              <b-icon-chevron-right
                font-scale="1"
                class="mt-1"
                v-if="currentStep >= 3 && structure == 'Section'"
              ></b-icon-chevron-right>
              <p class="stepper-text" v-if="currentStep >= 4 && structure == 'Section'">
                {{ payload.institution ? payload.course : "Select Course" }}
              </p>
              <b-icon-chevron-right
                font-scale="1"
                class="mt-1"
                v-if="currentStep >= 4 && structure == 'Section'"
              ></b-icon-chevron-right>
              <p class="stepper-text" v-if="currentStep >= 4 && structure == 'Subject'">
                {{ payload.institution ? payload.mode + " Mode" : "Select Mode" }}
              </p>
              <p class="stepper-text" v-if="currentStep >= 3 && structure == 'Untabbed'">
                {{ payload.institution ? payload.mode + " Mode" : "Select Mode" }}
              </p>
              <p class="stepper-text" v-if="currentStep >= 5 && structure == 'Section'">
                {{ payload.institution ? payload.mode + " Mode" : "Select Mode" }}
              </p>
            </div>
            <!-- {{ institutionsArray }} -->

            <b-overlay :show="loading">
              <template #overlay>
                <div class="text-center">
                  <b-icon-circle font-scale="3" animation="throb"></b-icon-circle>
                  <p class="text-center">Fetching Exam Categories... Please wait</p>
                </div>
              </template>
              <div class="stepper-div" style="min-height: 400px" v-if="currentStep == 1 && !loading2">
                <div
                  style=""
                  v-for="(item, index) in categoriesArray"
                  :key="index"
                  class="card-wrapper mt-2 px-3 py-2"
                  @click="(payload.category = item.name), categoryChanged(), currentCategoryObj = item"
                  :style="
                    payload.category == item.name ? 'border: 2px solid #243057' : ''
                  "
                >
                  <div class="w-100 h-100 d-flex flex-column justify-content-between">
                    <div>
                      <slot name="content">
                        <div class="d-flex justify-content-between fw-bold fs-3">
                          <p style="font-weight: bold; font-size: 20px">
                            {{ item.name }}
                          </p>
                        </div>
                      </slot>
                    </div>

                    <div class="w-100 d-flex justify-content-end" style="gap: 15px">
                      <p
                        v-if="item.premium"
                        class="d-flex"
                        style="font-weight: light; gap: 7px; font-size: 13px"
                      >
                        You have Premium Insitutions in this Category
                        <b-icon-award-fill
                          color="#243057"
                          class="mt-1"
                        ></b-icon-award-fill>
                      </p>
                      <b-icon-arrow-right scale="1.4"></b-icon-arrow-right>
                    </div>
                  </div>
                </div>
              </div>
            </b-overlay>

            <b-overlay :show="loading2">
              <template #overlay>
                <div class="text-center">
                  <b-icon-circle font-scale="3" animation="throb"></b-icon-circle>
                  <p class="text-center">Fetching Insitutions... Please wait</p>
                </div>
              </template>
              <div class="stepper-div" style="min-height: 300px" v-if="currentStep == 2">
                <div
                  style=""
                  v-for="(item, index) in institutionsArray"
                  :key="index"
                  class="card-wrapper mt-2 px-3 py-2"
                  @click="(payload.institution_id = item.track_id), institutionChanged()"
                  :style="
                    payload.institution_id == item.track_id
                      ? 'border: 2px solid #243057'
                      : ''
                  "
                >
                  <div class="w-100 h-100 d-flex flex-column justify-content-between">
                    <div>
                      <slot name="content">
                        <div class="">
                          <p style="font-weight: bold; font-size: 20px">
                            {{ item.name }} <br />
                            <span
                              style="font-weight: bold; font-size: 16px"
                              class="mt-n1"
                            >
                              ({{ item.short_name }})
                            </span>
                          </p>
                        </div>
                      </slot>
                    </div>

                    <div class="w-100 d-flex justify-content-end" style="gap: 15px">
                      <p
                        v-if="item.premium"
                        class="d-flex"
                        style="font-weight: light; gap: 7px; font-size: 13px"
                      >
                        You are on Premium for this Insitution
                        <b-icon-award-fill
                          color="#243057"
                          class="mt-1"
                        ></b-icon-award-fill>
                      </p>
                      <b-icon-arrow-right scale="1.4"></b-icon-arrow-right>
                    </div>
                  </div>
                </div>
              </div>
            </b-overlay>

            <div class="stepper-div" v-if="currentStep == 3 && structure == 'Section'">
              <div
                style=""
                v-for="(item, index) in levelsArray"
                :key="index"
                class="card-wrapper mt-2 px-3 py-2"
                @click="(payload.level = item.value), levelChanged()"
                :style="payload.level == item.value ? 'border: 2px solid #243057' : ''"
              >
                <div class="w-100 h-100 d-flex flex-column justify-content-between">
                  <div>
                    <slot name="content">
                      <div class="">
                        <p style="font-weight: bold; font-size: 20px">
                          {{ item.text }}
                          <br />
                        </p>
                      </div>
                    </slot>
                  </div>

                  <div class="w-100 d-flex justify-content-end" style="gap: 15px">
                    <p
                      v-if="item.premium"
                      class="d-flex"
                      style="font-weight: light; gap: 7px; font-size: 13px"
                    >
                      You are on Premium for this Level
                      <b-icon-award-fill color="#243057" class="mt-1"></b-icon-award-fill>
                    </p>
                    <b-icon-arrow-right scale="1.4"></b-icon-arrow-right>
                  </div>
                </div>
              </div>
            </div>

            <div class="stepper-div" v-if="currentStep == 3 && structure == 'Subject'">
              <b-form-group
                id="selsub"
                label=""
                label-size="lg"
                class="nested-form-group"
                v-if="structure == 'Subject'"
              >
                <h5>
                  Select Subject Combination (Maximum of
                  {{ payload.mode == "Topic" ? 1 : numberofSubjects }})
                </h5>
                <span>Please select the right subject combination</span>
                <b-form-checkbox-group
                  id="selectsubject"
                  v-model="payload.subjects"
                  :options="subjectsArray"
                  @change="topicMode"
                  name="subjectspo"
                  stacked
                  :state="substate"
                >
                  <b-form-invalid-feedback :state="substate"
                    >Please Select exactly
                    {{ payload.mode == "Topic" ? 1 : numberofSubjects }}
                    subject(s) to Proceed</b-form-invalid-feedback
                  >
                  <b-form-valid-feedback :state="substate"
                    >{{ payload.mode == "Topic" ? 1 : numberofSubjects }} Subject(s)
                    Selected Successfully, Proceed.</b-form-valid-feedback
                  >
                </b-form-checkbox-group>
              </b-form-group>
            </div>

            <div v-if="currentStep == 4 && structure == 'Section'">
              <div
                style=""
                v-for="(item, index) in coursesArray"
                :key="index"
                class="card-wrapper mt-2 px-3 py-2"
                @click="(payload.course = item.value), (currentStep = currentStep + 1)"
                :style="payload.course == item.value ? 'border: 2px solid #243057' : ''"
              >
                <div class="w-100 h-100 d-flex flex-column justify-content-between">
                  <div>
                    <slot name="content">
                      <div class="">
                        <p style="font-weight: bold; font-size: 20px">
                          {{ item.text }}
                          <br />
                        </p>
                      </div>
                    </slot>
                  </div>

                  <div class="w-100 d-flex justify-content-end" style="gap: 15px">
                    <p
                      v-if="item.premium"
                      class="d-flex"
                      style="font-weight: light; gap: 7px; font-size: 13px"
                    >
                      You are on Premium Insitutions for this Course
                      <b-icon-award-fill color="#243057" class="mt-1"></b-icon-award-fill>
                    </p>
                    <b-icon-arrow-right scale="1.4"></b-icon-arrow-right>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="stepper-div"
              v-if="
                (currentStep == 4 && structure == 'Subject') ||
                (currentStep == 5 && structure == 'Section') ||
                (currentStep == 3 && structure == 'Untabbed')
              "
            >
              <div
                style=""
                v-for="(item, index) in testModeArray"
                :key="index"
                class="card-wrapper mt-2 px-3 py-2"
                @click="payload.mode = item.value"
                :style="{
                  border: payload.mode == item.value ? '2px solid #243057' : '',
                  minHeight: currentStep == 4 && structure == 'Subject' ? '120px' : '',
                }"
              >
                <div class="w-100 d-flex flex-column justify-content-between">
                  <div>
                    <slot name="content">
                      <div class="">
                        <p
                          style="font-weight: bold; font-size: 20px; gap: 10px"
                          class="d-flex"
                        >
                          {{ item.text }}
                        </p>
                        <p style="font-size: 13px; margin-top: -13px">
                          {{ item.tooltip }}
                        </p>
                        <p
                          style="font-size: 12px"
                          v-if="
                            currentStep >= 4 &&
                            structure == 'Subject' &&
                            payload.subjects.length > 1 &&
                            item.value == 'Topic' &&
                            payload.mode == 'Topic'
                          "
                        >
                          Topic Mode can only accept one Subject. Please go back and tick
                          off other subjects and only tick one subject before you can
                          proceed
                        </p>

                        <div v-if="payload.mode == 'Flexible' && item.value == 'Flexible'" class="d-flex justify-content-between">
                          <p class="mb-3" style="font-weight: bold">
                            {{
                              payload.flexible_mode_type == 'custom' ? 'Select Custom values' : 'Select a Percentage reducer value'
                            }}
                          </p>

                          <p style="color: blue; font-weight: semibold;text-decoration:underline" @click="payload.flexible_mode_type == 'custom' ? payload.flexible_mode_type = 'reducer' : payload.flexible_mode_type = 'custom' ">
                            {{
                              payload.flexible_mode_type == 'custom' ? 'or Choose Percentage Reducer' : 'or Choose Custom values'
                            }}
                          </p>
                        </div>

                        <div v-if="payload.mode == 'Flexible' && item.value == 'Flexible' && payload.flexible_mode_type == 'custom'">
                          <b-form-group
                            class="nested-form-group"
                            label=""
                            label-for="testmode"
                            v-if="payload.mode == 'Flexible' && item.value == 'Flexible'"
                          >
                            <p class="form-label">
                              Number of questions for each subject in this test
                            </p>
                            <b-form-spinbutton
                              id="modeque"
                              v-model="payload.flexible_mode_no_questions"
                              min="0"
                              max="100"
                              step="1"
                            ></b-form-spinbutton>
                          </b-form-group>

                          <b-form-group v-if="payload.mode == 'Flexible' && item.value == 'Flexible'" label="" label-for="totmark">
                            <p class="form-label">Total Marks For this Tests</p>

                            <b-form-spinbutton
                              id="totmark"
                              v-model="payload.flexible_mode_totalmarks"
                              min="10"
                              max="500"
                              step="5"
                            ></b-form-spinbutton>
                          </b-form-group>

                          <b-form-group
                            class="nested-form-group"
                            label=""
                            label-for="testmode"
                            v-if="payload.mode == 'Flexible' && item.value == 'Flexible'"
                          >
                            <p class="form-label">
                              Time in minutes for this test
                            </p>

                            <b-form-spinbutton
                              id="modeque"
                              v-model="payload.flexible_mode_time"
                              min="0"
                              max="100"
                              step="1"
                            ></b-form-spinbutton>
                          </b-form-group>
                        </div>
                        

                        <b-form-group
                          class="nested-form-group"
                          v-if="payload.mode == 'Flexible' && item.value == 'Flexible' && payload.flexible_mode_type == 'reducer'"
                          label="Test Reducer (in percentage)"
                          label-for="testmode"
                        >
                          <b-form-spinbutton
                            id="totalque"
                            v-model="payload.flexible_mode_reducer"
                            min="25"
                            max="75"
                            step="25"
                          ></b-form-spinbutton>
                        </b-form-group>

                        <b-form-group
                          class="nested-form-group"
                          v-if="payload.mode == 'Topic' && item.value == 'Topic'"
                          label="Select Topic(s) to take test on"
                          label-for="testmode"
                        >
                          <b-form-checkbox-group
                            id="selecttopics"
                            v-model="payload.topics"
                            :options="topicsArray"
                            name="subjectspo"
                            stacked
                            :state="substate"
                          >
                            <b-form-invalid-feedback :state="substate2"
                              >Please Select exactly at least one Topic to Proceed and not
                              more than 4</b-form-invalid-feedback
                            >
                            <b-form-valid-feedback :state="substate2"
                              >Topics Selected Successfully,
                              Proceed.</b-form-valid-feedback
                            >
                          </b-form-checkbox-group>
                        </b-form-group>

                        <b-form-group
                          class="nested-form-group"
                          v-if="
                            payload.mode == 'Topic' &&
                            payload.topics.length != 0 &&
                            item.value == 'Topic'
                          "
                          label="Select No of Questions per Topic"
                          label-for="testmode"
                        >
                          <b-form-spinbutton
                            id="modeque"
                            v-model="payload.questionspertopic"
                            min="5"
                            max="10"
                            step="1"
                          ></b-form-spinbutton>
                        </b-form-group>

                        <b-form-group
                          class="nested-form-group"
                          v-if="
                            payload.mode == 'Topic' &&
                            payload.topics.length != 0 &&
                            item.value == 'Topic'
                          "
                          label="Select Minutes per Question"
                          label-for="testmode"
                        >
                          <b-form-spinbutton
                            id="modeque"
                            v-model="payload.minutesperquestion"
                            min="1"
                            max="2.5"
                            step="0.25"
                          ></b-form-spinbutton>
                        </b-form-group>
                      </div>
                    </slot>
                  </div>

                  <div class="w-100 d-flex justify-content-end" style="gap: 15px">
                    <!-- <p v-if="item.premium" class="d-flex" style="font-weight: light; gap:7px;font-size:13px">
                      You are on Premium Insitutions for this Level
                      <b-icon-award-fill color="#243057" class="mt-1"></b-icon-award-fill>
                    </p> -->
                    <b-icon-arrow-right scale="1.4"></b-icon-arrow-right>
                  </div>
                </div>
              </div>
            </div>

            <paginater
              v-if="
                (categoriesArray?.length > 0 || institutionsArray?.length > 0) &&
                currentStep <= 2 &&
                !loading
              "
              :intervalnum="intervalnum"
              :pages="pages"
              :endss="endss"
              :endnum="endnum"
              :datalength="endss"
              @paginator="newPage"
              @changeInterval="effectInterval"
            ></paginater>

            <div style="gap: 20px" class="d-flex justify-content-center">
              <div class="w-50">
                <b-button
                  class="w-100 p-2 d-block mt-3 btntxt"
                  variant="dark"
                  v-if="currentStep > 1"
                  @click="
                    (currentStep == 4 &&
                      structure == 'Subject' &&
                      structure.length > 0 &&
                      proceeding) ||
                    (currentStep == 5 &&
                      structure == 'Section' &&
                      structure.length > 0 &&
                      proceeding) ||
                    (currentStep == 3 &&
                      structure == 'Untabbed' &&
                      structure.length > 0 &&
                      proceeding)
                      ? stopproceed()
                      : (currentStep = currentStep - 1)
                  "
                >
                  {{
                    `${
                      ((currentStep > 0 &&
                        currentStep == 4 &&
                        structure == "Subject" &&
                        structure.length != 0) ||
                        (currentStep > 0 &&
                          currentStep == 5 &&
                          structure == "Section" &&
                          currentStep > 0 &&
                          currentStep == 3 &&
                          structure == "Untabbed" &&
                          structure.length != 0)) &&
                      proceeding
                        ? "Cancel"
                        : "Back"
                    }`
                  }}
                </b-button>
              </div>

              <div class="w-50">
                <b-overlay
                  :show="proceeding"
                  rounded
                  opacity="0.6"
                  spinner-small
                  spinner-variant="primary"
                  class="w-100"
                >
                  <b-button
                    class="w-100 p-2 mt-3 btntxt"
                    :disabled="
                      (currentStep < 4 && structure == 'Subject') ||
                      (currentStep < 5 && structure == 'Section') ||
                      (currentStep < 3 && structure == 'Untabbed') ||
                      structure.length == 0
                        ? false
                        : !substate
                    "
                    :variant="
                      (currentStep < 4 && structure == 'Subject') ||
                      (currentStep < 5 && structure == 'Section') ||
                      (currentStep < 3 && structure == 'Untabbed') ||
                      structure.length == 0
                        ? 'info'
                        : 'success'
                    "
                    @click="
                      (currentStep < 4 && structure == 'Subject') ||
                      (currentStep < 5 && structure == 'Section') ||
                      (currentStep < 3 && structure == 'Untabbed') ||
                      structure.length == 0
                        ? (currentStep = currentStep + 1)
                        : sendSelect()
                    "
                  >
                    {{
                      `${
                        (currentStep > 0 && currentStep != 4 && structure == "Subject") ||
                        (currentStep > 0 && currentStep != 5 && structure == "Section") ||
                        (currentStep > 0 &&
                          currentStep != 3 &&
                          structure == "Untabbed") ||
                        structure.length == 0
                          ? "Continue"
                          : "Take Test"
                      }`
                    }}
                  </b-button>
                </b-overlay>
              </div>
            </div>
          </div>
        </div>
      </b-col>
      <b-col md="3" class="bcol">
        <div></div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import store from "@/store";
import { mapState, mapActions } from "vuex";
import refreshLogin from "@/mixings/refreshLogin";
import Paginater from "@/components/Paginater";

export default {
  components: {
    Paginater,
  },
  data() {
    return {
      startnum: 0,
      limitnum: this.endss,
      intervalnum: 10,
      endnum: 10,
      btnrange: this.endss,
      pages: 1,
      curD: new Date(),
      proceeding: false,
      responses: "",
      payload: this.getselected(),
      categoriesArray: [],
      subjectsArray: [],
      institutionsArray: [],
      levelsArray: [],
      coursesArray: [],
      scholarshiptypearray: [],
      testModeArray: [
        {
          value: "Prototype",
          text: "Prototype Mode (default)",
          tooltip:
            "This mode mirrors the exact configuration of the test or exam you are practicing for, prototyping the test/exam as if you are writing the exam.",
        },
        {
          value: "Flexible",
          text: "Flexible Mode",
          tooltip:
            "With this mode, you have the option to specify the amount of time and questions you want to practice with. You can choose to practice a percentage of the total configuration of the exam only. This Mode adds extra Flexibility to your practices",
        },
        {
          value: "Speed",
          text: "Speed Mode",
          tooltip:
            "This mode will help develop speed while taking a test or exam. The total time for the exam is divided equally to each question, therefore, you have as much time for each question. Here, you will be taught how to manage time in the exam hall.",
        },
        {
          value: "Accuracy",
          text: "Accuracy mode",
          tooltip:
            "This mode caters for another quality required from a candidate alongside speed - accuracy. In this mode all locked questions will be opened when 80% of the total time has elapses, allowing you to go over your work to ensure there are no mistakes.",
        },
        {
          value: "Topic",
          text: "Topic Mode",
          tooltip:
            "Struggling with a particular concept or topic? This mode lets you focus on specific topics, honing your skills and boosting your confidence. It helps you Conquer your weak areas and achieve mastery.",
        },
      ],
      topicsArray: [],
      structure: "",
      sameName: "",
      org: "Quicktest",
      countdown: 5,
      query: "",
      meta: {},
      currentStep: 1,
      currentInstitutionObj: {},
      currentCategoryObj: {},
      loading: false,
      loading2: false,
      //chkcatarr: false
    };
  },
  beforeRouteEnter(to, from, next) {
    store.dispatch("exam/retrieveCategories");
    store.dispatch("exam/retrieveInstitutions");
    store.dispatch("exam/destroyAlreadysub");
    store.dispatch("exam/retrieveTopics");
    next();
  },
  mixings: [refreshLogin],

  async mounted() {
    // If there is a Test going on already in the testhall and the user managed to navigate into this page, route the user back to the testhall immediately
    if (this.started) {
      this.movedown();
    }

    await this.fetchCategoryData();

    if (this.start_config.start == "Yes") {
      this.$router.push({
        name: "confirm",
        params: {
          trackid: this.start_config.track_id,
        },
      });
    }

    if (this.categoriesArray.length > 0) {
      // If the category Array has been populated by the response from the Api
      let inst = this.allinsti.filter((x) => x.available == "Yes").map((x) => x.name); // Get all the Institutions that are marked as available and map their fullnames to an Array

      this.institutionsArray = inst; // set the Data property institutionsArray with this value
      let typesarr = this.categoriesArray; // Get the Categories and map their names to the 'typesarray'
      this.categoriesArray = typesarr; // set the value of the data property 'categoriesArray' to this value
    } else {
      // If the initial API call did not send back the response on time, dispatch another request and this time wait for the request to send a response before doing any further operation
      store.dispatch("exam/retrieveCategories").then(() => {
        store.dispatch("exam/retrieveInstitutions");

        let inst = this.allinsti.filter((x) => x.available == "Yes").map((x) => x.name); // Get all the Institutions that are marked as available and map their fullnames to an Array

        this.institutionsArray = inst; // set the Data property institutionsArray with this value
        let typesarr = this.categoriesArray; // Get the Categories and map their names to the 'typesarray'
        this.categoriesArray = typesarr; // set the value of the data property 'categoriesArray' to this value
      });
    }
  },

  watch: {
    countdown(oldval, newval) {
      if (oldval > newval) {
        this.reduceCountdown();
      }
    },
    "payload.mode"() {
      if (this.payload.mode == "Topic") {
        let categoryconfig = this.categoriesArray.filter(
          (x) => x.name == this.payload.category
        );

        if (categoryconfig[0].structure == "Section") {
          let currentTopics = this.alltopics
            .filter(
              (x) =>
                x.topic_for == this.payload.course &&
                x.institution == this.payload.institution &&
                x.category == this.payload.category
            )
            .map((x) => x.topic);

          this.topicsArray = currentTopics;
        } else if (categoryconfig[0].structure == "Subject") {
          let currentTopics = this.alltopics
            .filter(
              (x) =>
                x.topic_for == this.payload.subjects[0] &&
                x.institution == this.payload.institution &&
                x.category == this.payload.category
            )
            .map((x) => x.topic);

          this.topicsArray = currentTopics;
        }
      }
    },
    "payload.course"() {
      if (this.payload.mode == "Topic") {
        let categoryconfig = this.categoriesArray.filter(
          (x) => x.name == this.payload.category
        );

        if (categoryconfig[0].structure == "Section") {
          let currentTopics = this.alltopics
            .filter(
              (x) =>
                x.topic_for == this.payload.course &&
                x.institution == this.payload.institution &&
                x.category == this.payload.category
            )
            .map((x) => x.topic);

          this.topicsArray = currentTopics;
        } else if (categoryconfig[0].structure == "Subject") {
          let currentTopics = this.alltopics
            .filter(
              (x) =>
                x.topic_for == this.payload.subjects[0] &&
                x.institution == this.payload.institution &&
                x.category == this.payload.category
            )
            .map((x) => x.topic);

          this.topicsArray = currentTopics;
        }
      }
    },
    currentStep(newval) {
      if (newval == 1) {
        this.fetchCategoryData();
      }

      if (newval == 2 && this.sameName == "Yes") {
        this.currentStep = 1;
      }
    },
  },

  methods: {
    proceed() {
      this.proceeding = true; // Set value of the data property 'proceeding' to true. This triggers the spinner to come up and also disables the proceed button
    },

    getselected() {
      return {
        organization: this.$store.state.loginmaster.details.quicktest_details
          .organization_name,
        organization_id: this.$store.state.loginmaster.details.quicktest_details.track_id,
        category: null,
        institution: null,
        institution_id: "",
        level: null,
        course: null,
        scholarship: null,
        subjects: [],
        topics: [],
        flexible_mode_reducer: 25,
        flexible_mode_type: "custom",
        flexible_mode_time: 10,
        flexible_mode_totalmarks: 100,
        flexible_mode_no_questions: 10,
        questionspertopic: 5,
        minutesperquestion: 1,
        mode: "Prototype",
        testspaceid: "",
        testsource: "base",
        candidate: this.$store.state.loginmaster.details,
      };
    },
    ...mapActions("exam", [
      "setSelect",
      "retrieveInstitutions",
      "retrieveAllInstitutionsTabled",
      "retrieveAllCategoriesTabled",
    ]),
    ...mapActions("loginmaster", ["setPlan"]),
    ...mapActions("exam", ["retrieveCategories"]),

    async fetchCategoryData() {
      this.loading = true;
      try {
        const response = await this.retrieveAllCategoriesTabled();

        this.categoriesArray = response.data;
        this.meta = response.meta;

        this.poolPremiumCategories();

        this.loading = false;
      } catch {
        this.loading = false;
      }
    },
    async fetchInstitutionsData() {
      this.loading2 = true;
      this.query =
        this.query.length > 0
          ? `${this.query}&category=${this.payload.category}&orgId=${this.details.quicktest_details.track_id}`
          : `?category=${this.payload.category}&orgId=${this.details.quicktest_details.track_id}`;

      try {
        const response = await this.retrieveAllInstitutionsTabled(this.query);

        this.institutionsArray = response.data;
        this.meta = response.meta;

        this.poolPremiumInstitutions();

        this.loading2 = false;
      } catch {
        this.loading2 = false;
      }
    },
    // This Method sends the all the Users selected options to the state actions then to the api service then to the backend. The response is the Test Parameters
    sendSelect() {
      this.proceed();
      return this.setSelect(this.payload).then(() => {
        if (this.start_config.start == "Yes") {
          this.$router.push({
            name: "confirm",
          });
        }
      });
    },
    poolPremiumCategories() {
      if (this.plan == "Premium") {
        // If user is a Premium User, Populate the select boxes Arrays with Only Premium values as sent along with the user details
        this.premium.category.forEach((x) => {
          const xIndex = this.categoriesArray.findIndex((y) => y.name === x.value);

          if (xIndex >= 0) {
            const deleted = this.categoriesArray.splice(xIndex, 1);
            deleted[0]["premium"] = true;
            this.categoriesArray.unshift(deleted[0]);
          }
        });
      }
    },
    poolPremiumInstitutions() {
      if (this.plan == "Premium") {
        // If user is a Premium User, Populate the select boxes Arrays with Only Premium values as sent along with the user details
        this.premium.institutions.forEach((x) => {
          const xIndex = this.institutionsArray.findIndex((y) => y.track_id == x.value);

          if (xIndex >= 0) {
            const deleted = this.institutionsArray.splice(xIndex, 1);
            deleted[0]["premium"] = true;
            this.institutionsArray.unshift(deleted[0]);
          }
        });
      }
    },
    poolPremiumLevels() {
      if (this.plan == "Premium") {
        // If user is a Premium User, Populate the select boxes Arrays with Only Premium values as sent along with the user details
        this.premium.levels.forEach((x) => {
          const xIndex = this.levelsArray.findIndex((y) => y.value == x.value);

          console.log(xIndex);
          if (xIndex >= 0) {
            const deleted = this.levelsArray.splice(xIndex, 1);
            deleted[0]["premium"] = true;
            this.levelsArray.unshift(deleted[0]);
          }
        });
      }
    },
    movedown() {
      let categoryName = JSON.parse(this.start_config.category).name;
      this.$router.push({
        name: "testhall",
        params: {
          trackid: this.start_config.track_id,
          category: categoryName,
          institution: this.start_config.institution_shortname,
        },
      });
    },
    reduceCountdown() {
      this.countdown = this.countdown - 1;
      setTimeout(() => {
        // this.countdown = this.countdown - 1;
        this.reduceCountdown();
        if (this.countdown == 0) {
          this.movedown();
        }
      }, 1000);
    },
    stopproceed() {
      this.proceeding = false; // If user clicks the cancel button, stops the spinner and enables the proceed button.
    },
    newPage(page) {
      // alert(page)
      this.pages = page;
      //   let newend = this.intervalnum * page;

      // let search = this.query.length > 0 ? `&search=${this.query}` : "";
      this.query =
        this.query.length > 0
          ? `${this.query}&page=${this.pages}&perPage=${this.intervalnum}`
          : `?page=${this.pages}&perPage=${this.intervalnum}`;
      this.fetchInstitutionsData();
    },
    effectInterval(newinterval) {
      this.intervalnum = newinterval;
      this.pages = 1;
      this.newPage(this.pages);
    },
    clearField() {
      this.searchQuery = "";
      this.closeSearch();
    },

    async clearFilter(event) {
      if (event?.length == 0) {
        this.setQuery(`page=${this.pages}&perPage=${this.intervalnum}`);
        this.fetchCategoryData();
      }
    },

    async searchFilter() {
      this.searching = true;
      //   let query = this.searchQuery;

      try {
        if (this.searchQuery.length == 0) {
          this.clearField();
          this.setQuery(`page=${this.pages}&perPage=${this.intervalnum}`);
          await this.fetchTestspaces();
          this.searching = false;
        } else {
          this.setQuery(
            `page=${this.pages}&perPage=${this.intervalnum}&search=${this.searchQuery}`
          );
          await this.fetchTestspaces();
          this.searching = false;
        }
      } catch {
        // PUt something here
      }
    },
    closeSearch() {
      this.searching = false;
      this.searchQuery = "";
    },
  },
  computed: {
    ...mapState({
      details: (state) => state.loginmaster.details,
      loggedin: (state) => state.loginmaster.loggedIn,
      start_config: (state) => state.exam.start_config,
      plan: (state) => state.loginmaster.details.plan,
      trial: (state) => state.loginmaster.trial,
      premium: (state) => state.loginmaster.details.premium_details,
      started: (state) => state.exam.started,
      allinsti: (state) => state.exam.allinstitutions,
      // Categories: state => state.exam.allcategories,
      alltopics: (state) => state.exam.alltopics,
      ongoing: (state) => state.ongoing,
    }),
    substate() {
      if (this.payload.mode == "Topic") {
        if (this.structure != "Section") {
          // Checks if the number of subjects picked is the same as the number of Subjects required for this exam and if all fields has been selected
          return this.payload.subjects.length == 1 &&
            this.payload.topics.length > 0 &&
            this.payload.topics.length <= 4
            ? true
            : (false && this.payload.institution == null) || this.proceeding;
        } else {
          // Checks if all required fields has been selected
          return this.payload.topics.length > 0 && this.payload.topics.length <= 4
            ? true
            : (false && this.payload.level != null && this.payload.course != null) ||
                this.proceeding;
        }
      } else {
        if (this.structure == "Subject") {
          // Checks if the number of subjects picked is the same as the number of Subjects required for this exam and if all fields has been selected
          return this.payload.subjects.length ==
            this.allinsti
              .filter((x) => x.name == this.payload.institution)
              .map((x) => x.num_courses)[0]
            ? true
            : (false && this.payload.institution == null) || this.proceeding;
        } else if (this.structure == "Section") {
          // Checks if all required fields has been selected
          return (
            (this.payload.level != null && this.payload.course != null) || this.proceeding
          );
        } else if (this.structure == "Untabbed") {
          return this.payload.institution != null || this.proceeding;
        } else {
          return false;
        }
      }
    },
    substate2() {
      return this.payload.topics.length == 0 ? false : true;
    },

    numberofSubjects() {
      // returns the number of subjects required for the selected institution
      return this.allinsti
        .filter((x) => x.name == this.payload.institution)
        .map((x) => x.num_courses)[0];
    },
    chkcatarr() {
      return this.categoriesArray.length > 0 ? true : false;
    },
    endss() {
      let end = this.meta?.total;
      return end;
    },
  },
};
</script>

<style scoped>
.nested-form-group {
  text-align: left;
}

.root {
  padding: 10px;
  min-height: 400px;
}

.bcol {
  padding: 10px;
}

.select-wrap {
  background-color: rgb(255, 255, 255);
  border: 1px solid gray;
  box-sizing: content-box;
  padding: 20px;
  border-radius: 10px 10px;
}

.select-wrap p {
  text-align: left;
}

.btn-md {
  font-size: 21px;
  font-weight: bold;
  color: #00377b;
  cursor: pointer;
}

.swel {
  font-size: 27px;
}

.btntxt {
  font-size: 1.3rem;
}
.v-button {
  border-radius: 10px 10px;
  width: 10rem;
  background-color: #00984a;
  font-weight: bolder;
  color: white;
  border: 0px;
  font-size: 18px;
}
.v-button:hover {
  background-color: white;
  color: #00984a;
  border: 1px solid #00984a;
}

.card-wrapper {
  width: 100%;
  border: 1px solid white;
  border-radius: 10px 10px;
  background: #c6ead8;
  cursor: pointer;
}

.card-wrapper:hover {
  border: 2px solid #243057;
}

.stepper-div {
  min-height: 300px;
}

.stepper-text {
  font-weight: bold;
}

.info-span {
  display: block;
  text-align: left;
  color: white;
}

@media (max-width: 768px) {
  .btn-md {
    width: 100%;
    font-size: 15px;
  }
  .v-button {
    width: inherit;
    /* height: 2.5rem; */
    font-size: 0.8rem;
  }

  .swel {
    font-size: 20px;
  }
}
</style>
